import { render, staticRenderFns } from "./CardSuperior.vue?vue&type=template&id=1f682c4c&scoped=true&"
import script from "./CardSuperior.vue?vue&type=script&lang=js&"
export * from "./CardSuperior.vue?vue&type=script&lang=js&"
import style0 from "./CardSuperior.vue?vue&type=style&index=0&id=1f682c4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f682c4c",
  null
  
)

export default component.exports